module.exports = __webpack_public_path__ + "static/media/logoInPages.71fea9cd.GIF";